import MuiAvatarGroup from '@material-ui/lab/AvatarGroup';

export default MuiAvatarGroup;
